export const UPDATE_FAVORITES = 'UPDATE_FAVORITES [USER]';
export const UPDATE_RECENTLY_VIEWED_CARDS = 'UPDATE_RECENTLY_VIEWED_CARDS [USER]';
export const TOGGLE_FAVORITE_CURATED_COLLECTION = 'TOGGLE_FAVORITE_CURATED_COLLECTION [USER]';

import { notificationPrompt } from 'js/store/notification/notification.actions';

export const updateFavorites = (id) => {
  return (dispatch, getState) => {
    const state = getState();

    if (state.user.favorites.includes(id)) {
      dispatch(notificationPrompt({ type: 'FAVORITE_REMOVED', additionalData: false }));
    } else {
      dispatch(notificationPrompt({ type: 'FAVORITE_ADDED', additionalData: false }));
    }

    dispatch({
      type: UPDATE_FAVORITES,
      payload: id,
    });
  };
};

export const updateRecentlyViewedCards = (cardId) => ({
  type: UPDATE_RECENTLY_VIEWED_CARDS,
  payload: cardId,
});

export const toggleFavoriteCuratedCollection = (collectionId) => ({
  type: TOGGLE_FAVORITE_CURATED_COLLECTION,
  payload: { collectionId },
});
